import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import router from '../main.js'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.baseURL = 'https://mr.summary88.com/';
//axios.defaults.baseURL = 'http://192.168.0.50/mrol/public/';

axios.interceptors.request.use((config) => {
	let token = Vue.prototype.getCookie('token');
	if(token && token != undefined && token != 'undefined') {
		config.headers['token'] = token;
	}
	return config;
}, (error) => {
	return Promise.reject(error);
});

axios.interceptors.response.use(
	response => {
		console.log(response)
		if(response.data.code == '-1') {
			layui.use('layer', () => {
				var layer = layui.layer;
				layer.msg('登录已过期，请重新登录', {
					icon: 2,
					anim: 6
				})
			})
			setTimeout(function() {
				router.replace('login')
			}, 1500)
		}
		return response;
	},
	error => {

	}
);

export default {
	// 获取验证码
	getCodes(params) {
		let url = 'api/Factory/getCode'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工厂用户注册
	register(params) {
		let url = 'api/Factory/register'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 忘记密码
	forgetPwd(params) {
		let url = 'api/Factory/forgetPwd'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  完善工厂信息 
	fillInfo(params) {
		let url = 'api/Factory/fillInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 会员中心
	getOrderCountInfo(params) {
		let url = 'api/Factory/getOrderCountInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取用户注册信息
	getMemberInfo(params) {
		let url = 'api/Factory/getMemberInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 修改在线状态
	changeOnLineStatus(params) {
		let url = 'api/Factory/changeOnLineStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 登录
	userLogin(params) {
		let url = 'api/Factory/login'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 修改密码
	editPwd(params) {
		let url = 'api/Factory/editPwd'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工资明细
	getWagesLog(params) {
		let url = 'api/Factory/getWagesLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 任务大厅
	TaskList(params) {
		let url = 'api/Order/fTaskList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 接单
	receiptOrder(params) {
		let url = 'api/Order/fReceiptOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取我的订单
	OrderList(params) {
		let url = 'api/Order/fOrderList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取订单详情
	getOrderDetail(params) {
		let url = 'api/Order/getOrderDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 材料信息
	getMaterialInfo(params) {
		let url = 'api/Factory/getMaterialInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 材料明细
	getMaterialLog(params) {
		let url = 'api/Factory/getMaterialLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 领料
	confirmLog(params) {
		let url = 'api/Factory/confirmLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工厂售后订单列表
	fSaleOrderList(params) {
		let url = 'api/Order/fSaleOrderList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 详情下单
	max_add_express(params) {
		let url = 'api/Express/max_add_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	query_express(params) {
		let url = 'api/Express/query_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工厂材料不足申诉
	fAppealOrder(params) {
		let url = 'api/Order/fAppealOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工厂收货地址列表
	getAddressList(params) {
		let url = 'api/Factory/getAddressList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 新增工厂收货地址
	addAddress(params) {
		let url = 'api/Factory/addAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 编辑工厂收货地址
	editAddress(params) {
		let url = 'api/Factory/editAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	setDefaultAddress(params) {
		let url = 'api/Factory/setDefaultAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	delAddress(params) {
		let url = 'api/Factory/delAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 顺丰下单接口
	f_add_express(params) {
		let url = 'api/Express/f_add_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 订单进度
	getOrderProgress(params) {
		let url = 'api/Order/getOrderProgress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工资明细的明细
	getOrderWages(params) {
		let url = 'api/Factory/getOrderWages'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 等级评分
	getFractionLog(params) {
		let url = 'api/Factory/getFractionLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//站内公告
	notice(params) {
		let url = '/api/Index/notice'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//德邦物流轨迹查询
	debang(params) {
		let url = '/api/Express/gj_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//顺丰物流轨迹查询
	shunfeng(params) {
		let url = '/api/Express/f_query_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//京广下单
	jg_express(params) {
		let url = '/api/Express/jg_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//京广物流轨迹查询
	jg_query(params) {
		let url = '/api/express/jg_query'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//信丰下单
	xf_express(params) {
		let url = '/api/Express/xf_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//信丰物流轨迹查询
	xf_query(params) {
		let url = '/api/Express/xf_query'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//京东下单
	jd_express(params) {
		let url = '/api/Express/jd_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//京东物流轨迹查询
	jd_query(params) {
		let url = '/api/Express/jd_query'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//获取服务条款
	gc_secrecy(params) {
		let url = '/api/Index/gc_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工程师服务条款》》》》3个端的服务条款
	gcsSecrecy(params) {
		let url = '/api/Index/gcs_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业服务条款》》》》3个端的保密协议
	qySecrecy(params) {
		let url = '/api/Index/qy_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 新增
	selfraising(params) {
		let url = '/api/Express/self_raising'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 新增
	selfdistribution(params) {
		let url = '/api/Express/self_distribution'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题分类
	getQuestionCategory(params) {
		let url = '/api/Question/getQuestionCategory'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题列表
	getQuestionList(params) {
		let url = '/api/Question/getQuestionList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题详情
	getQuestionDetail(params) {
		let url = '/api/Question/getQuestionDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
}


// WEBPACK FOOTER //
// ./src/utils/api.js